var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { forwardRef, useCallback, useMemo } from 'react';
import styled from 'styled-components';
import { Calendar as CalendarIcon } from '@creditornot/cb-icons';
import { Input } from '@creditornot/cb-input';
import DateMultiPicker from './DateMultiPicker';
import DatePickerPopover from './DatePickerPopover';
import { defaultLocale, getLocaleCode } from './utils';
var EMPTY_SELECTION = [];
var DatePickerContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 4px 16px 20px 16px;\n"], ["\n  padding: 4px 16px 20px 16px;\n"])));
var DateMultiPickerInput = function (_a, ref) {
    var children = _a.children, className = _a.className, disableClear = _a.disableClear, disabled = _a.disabled, disabledDays = _a.disabledDays, disableMonthChange = _a.disableMonthChange, disableOutsideDaysClick = _a.disableOutsideDaysClick, disableYearSelect = _a.disableYearSelect, formatValue = _a.formatValue, _b = _a.inputIcon, inputIcon = _b === void 0 ? React.createElement(CalendarIcon, null) : _b, invalid = _a.invalid, _c = _a.locale, locale = _c === void 0 ? defaultLocale : _c, onBlur = _a.onBlur, onChange = _a.onChange, onFocus = _a.onFocus, placeholder = _a.placeholder, popoverPlacement = _a.popoverPlacement, popoverZIndex = _a.popoverZIndex, rootRef = _a.rootRef, showOutsideDays = _a.showOutsideDays, style = _a.style, timezone = _a.timezone, value = _a.value;
    var IntlDateTimeFormat = useMemo(function () {
        var options = timezone ? { timeZone: timezone } : undefined;
        return new Intl.DateTimeFormat(getLocaleCode(locale), options);
    }, [locale, timezone]);
    var defaultFormatValue = useCallback(function (value) {
        if (value.length === 0) {
            return '';
        }
        if (value.length === 1) {
            return IntlDateTimeFormat.format(value[0]);
        }
        return "".concat(value.length, " dates selected");
    }, [IntlDateTimeFormat]);
    var formattedValue = value && value.length > 0
        ? (formatValue || defaultFormatValue)(value, { timeZone: timezone })
        : '';
    return (React.createElement(DatePickerPopover, { content: React.createElement(DatePickerContainer, null,
            React.createElement(DateMultiPicker, { disableMonthChange: disableMonthChange, disableOutsideDaysClick: disableOutsideDaysClick, disableYearSelect: disableYearSelect, disabledDays: disabledDays, locale: locale, onChange: onChange, showOutsideDays: showOutsideDays, timezone: timezone, value: value })), contentZIndex: popoverZIndex, onCloseStart: onBlur, placement: popoverPlacement }, children
        ? function (props) { return children(__assign(__assign({}, props), { value: value, formattedValue: formattedValue })); }
        : function () { return (React.createElement(Input, { className: className, disabled: disabled, icon: inputIcon, invalid: invalid, onClearClick: disableClear
                ? undefined
                : function () {
                    if (onChange) {
                        onChange(EMPTY_SELECTION);
                    }
                }, onFocus: onFocus, placeholder: placeholder, readOnly: true, ref: ref, rootRef: rootRef, style: style, value: formattedValue })); }));
};
export default forwardRef(DateMultiPickerInput);
var templateObject_1;
//# sourceMappingURL=DateMultiPickerInput.js.map